module.exports = require("next/dist/compiled/undici");